var _ellipse, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEasytouse(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_3616",
    "data-name": "Group 3616",
    xmlns: "http://www.w3.org/2000/svg",
    width: 61,
    height: 59,
    viewBox: "0 0 61 59",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_8",
    "data-name": "Ellipse 8",
    cx: 30.5,
    cy: 29.5,
    rx: 30.5,
    ry: 29.5,
    fill: "#eaeaff"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "bahai",
    d: "M13.412,22.8l3.381,2.6a1.33,1.33,0,0,0,2.109-.739l.855-4.082,4.325-.1A1.266,1.266,0,0,0,25.2,18.607l-2.071-3.656L26.379,12.2a1.243,1.243,0,0,0-.39-2.127L21.961,8.552l.647-4.117a1.3,1.3,0,0,0-1.719-1.389l-4.1,1.328L14.534.823a1.342,1.342,0,0,0-2.244,0L10.035,4.377l-4.1-1.328A1.3,1.3,0,0,0,4.216,4.437l.647,4.117L.835,10.072A1.244,1.244,0,0,0,.445,12.2L3.69,14.952,1.62,18.608a1.266,1.266,0,0,0,1.122,1.871l4.325.1.855,4.082a1.33,1.33,0,0,0,2.109.739l3.381-2.6Z",
    transform: "translate(16.966 16.985)",
    fill: "#3b00ff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEasytouse);
export default __webpack_public_path__ + "static/media/easytouse.170e67cbb941cdcd846fabb8113220f0.svg";
export { ForwardRef as ReactComponent };